import { render } from "./CheckboxSingle.vue?vue&type=template&id=9cdcb4ae&scoped=true"
import script from "./CheckboxSingle.vue?vue&type=script&lang=js"
export * from "./CheckboxSingle.vue?vue&type=script&lang=js"

import "./CheckboxSingle.vue?vue&type=style&index=0&id=9cdcb4ae&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cdcb4ae"]])

export default __exports__